import React from 'react'
import Title from './Title'
import Subtitle from './Subtitle'
import { Flex } from 'antd'

const cssNumber = {
  color: '#ff4438',
  fontWeight: 'bold',
  display: 'inline-block',
  width: '1.5em'
}

export default function Consultation () {
  return (
    <>
      <Title text={"Déroulé d'une consultation"} />
      <div style={{ padding: '0 20px' }}>
        <Subtitle text={"A l'extérieur"} />
        <Flex vertical gap='0.5em' style={{ fontSize: '20px', marginBottom: '10px' }}>
          <div>
            <span style={cssNumber}>1</span>
            Prenez un rendez-vous sur <a href="https://laboxmedicale.com" style={{ color: '#ff4438', fontWeight: 'bold' }}>laboxmedicale.com</a> ou Flashez le QR code ou appelez-nous
          </div>
          <div>
            <span style={cssNumber}>2</span>
            Réservez votre créneau horaire ou prenez un rendez-vous immédiat
          </div>
          <div>
            <span style={cssNumber}>3</span>
            Recevez le code d&apos;accès à la Box Médicale par SMS
          </div>
          <div>
            <span style={cssNumber}>4</span>
            C&apos;est l&apos;heure de votre rendez-vous&nbsp;: <b>tapez le code</b>
          </div>
          <div>
            <span style={cssNumber}>5</span>
            La porte s&apos;ouvre, nous vous souhaitons une bonne consultation!
          </div>
        </Flex>
        <Subtitle text={"A l'intérieur"} />
        <Flex vertical gap='0.5em' style={{ fontSize: '20px', marginBottom: '10px' }}>
          <div>
            <span style={cssNumber}>6</span>Installez vos affaires sur le mobilier
          </div>
          <div>
            <span style={cssNumber}>7</span>Dirigez-vous vers la borne
          </div>
          <div>
            <span style={cssNumber}>8</span>Votre consultation commence
          </div>
          <div>
            <span style={cssNumber}>9</span>En cas de besoin utilisez l&apos;interphone, un opérateur va vous répondre
          </div>
          <div>
            <span style={cssNumber}>10</span>Après votre départ, la désinfection de la Box Médicale est réalisée automatiquement
          </div>
        </Flex>
      </div >
    </>
  )
}
